interface Props {
  settings: any;
  setSettings: any;
}
const UserForm = (props: Props) => {
  // const { settings, setSettings } = props;
  return <></>;
};

export default UserForm;
